
import button from "./button.js"

export default {
    ...button
}